import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-info-card",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./info-card.component.html",
})
export class InfoCardComponent {
  @Input() title = "";
  @Input() message = "";
  @Input() className = "w-full lg:mt-4 md:mt-10 mx-auto"; // Default class for the card can be overridden for any purpose
}
